// @ts-nocheck
import getImageSize from "@store/Framework/Common/Utilities/getImageSize";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    accordion: {
        padding: {
            horizontal: pxToRemArray([20]),
            vertical: pxToRemArray([20]),
        },
        spacing: pxToRemArray([2]),
    },
    autocomplete: {
        link: {
            color: "inherit",
            hoverColor: "text.linkAltHover",
            underline: false,
            hoverUnderline: true,
        },
        columnHeader: {
            margin: {
                horizontal: pxToRem(5),
            },
        },
    },
    button: {
        field: {
            enabled: true,
            scaling: 0,
        },
    },
    category: {
        image: {
            small: getImageSize(768),
            large: getImageSize(1410, 550),
        },
    },
    common: {
        contentRadius: pxToRem(6),
    },
    form: {
        actions: {
            gap: pxToRem(8),
            spacing: "1.5em",
        },
        grid: {
            small: {
                horizontal: pxToRemArray([20]),
                vertical: ["0.75em"],
            },
            base: {
                horizontal: pxToRemArray([30]),
                vertical: ["1em"],
            },
        },
    },
    layout: {
        contentWidth: 1410,
        spacing: {
            side: pxToRemArray([20, 30, 45, null, 60]),
            content: pxToRemArray([25, 30, 45, null, 60]),
            narrowContent: pxToRemArray([25, 30, 40, null, 50]),
            spacedContent: pxToRemArray([30, 40, 55, null, 75]),
        },
    },
    /* Store Custom Code - Start */
    header: {
        breakpoint: "md",
        height: pxToRemArray([65, null, 80, 96]),
        padding: pxToRemArray([17, null, 15]),
        itemSpacing: pxToRemArray([4, null, 40, 50, 60]),
        subItemSpacing: pxToRemArray([2, null, 20, 36, 50]),
        iconButton: {
            size: pxToRemArray([28]),
            padding: pxToRemArray([5, null, 0]),
        },
    },
    menu: {
        panel: {
            rowPadding: pxToRem(16),
            rowWrapperPadding: pxToRem(0, 0),
        },
        mainNavigation: {
            height: pxToRemArray([45, null, null, 48]),
            itemSpacing: pxToRemArray([27]),
            megaMenuFullWidth: false,
            underlineSize: pxToRem(2),
        },
        secondaryNavigation: {
            height: pxToRemArray([36]),
            itemSpacing: pxToRemArray([35, null, null, 40]),
            iconSpacing: pxToRem(7),
            separatorSize: pxToRem(0),
        },
        megaMenuWithTabs: {
            minHeight: pxToRem(350),
            spacing: pxToRem(30),
            tabs: {
                childSpacing: pxToRem(14, 24, 14, 15),
                spacingLeft: pxToRem(36),
                width: pxToRemArray([null, null, 288, 328, 376]),
            },
            tabsContent: {
                spacing: pxToRem(43, 68),
            },
        },
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        detail: {
            contentSpacing: pxToRem(11),
        },
        list: {
            contentSpacing: pxToRem(8),
        },
    },
    typography: {
        /* Store Custom Code - Start */
        fontFamily: {
            title: `'Cencora', sans-serif, 'Arial'`,
            base: `'Cencora', sans-serif, 'Arial'`,
        },
        /* Store Custom Code - End */
        letterSpacing: {
            base: pxToRem(0),
            large: pxToRem(0.5),
            larger: pxToRem(1),
        },
        lineHeight: {
            smaller: 1,
            small: 1.25,
            semi: 1.375,
            base: 1.5,
            large: 1.75,
            larger: 2,
        },
        size: {
            tiny: pxToRem(12),
            smallest: pxToRem(13),
            smaller: pxToRem(14),
            small: pxToRem(15),
            base: pxToRem(16),
            large: pxToRem(18),
            larger: pxToRem(20),
            largest: pxToRem(24),
        },
        spacing: {
            smaller: "0.25em",
            small: "0.5em",
            base: "1em",
            large: "1.5em",
            larger: "2em",
        },
        weight: {
            thin: 100,
            extralight: 200,
            light: 300,
            base: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
            extrabold: 800,
            black: 900,
        },
    },
};

export default design;
